// extracted by mini-css-extract-plugin
export var attachment = "_p1-a";
export var emailContainer = "_p1-4";
export var emailContentPaddedContainer = "_p1-b";
export var emailHeader = "_p1-6";
export var emailIframe = "_p1-3";
export var emailInfoIcon = "_p1-9";
export var emailShortenedSummary = "_p1-e";
export var infoDropdown = "_p1-0";
export var infoRowBoundedContent = "_p1-d";
export var internal = "_p1-5";
export var merchant = "_p1-8";
export var messageInputContainer = "_p1-h";
export var normal = "_p1-7";
export var replyCard = "_p1-f";
export var subtleButton = "_p1-1";
export var subtleButtonIconContainer = "_p1-2";
export var toggleViewRepliesButton = "_p1-c";
export var wrappingText = "_p1-g";